import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 6v3","key":"svg-0"}],["path",{"d":"M14 6v3","key":"svg-1"}],["path",{"d":"M5 11a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2l0 -8","key":"svg-2"}],["path",{"d":"M10 15a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-3"}],["path",{"d":"M9 3h6v3h-6l0 -3","key":"svg-4"}]]

const IconPerfume = createReactComponent('outline', 'perfume', 'Perfume', __iconNode);

export default IconPerfume;